import { HeaderContainer as Header } from '../HeaderTemplate/HeaderContainer';
/**
 * Header containing the navigation links
 */
export const HeaderMinimal = () => <Header />;
